var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4937 40C13.6417 38.2253 7.77573 33.8037 4.18627 27.7077C0.59682 21.6117 -0.42216 14.3406 1.35348 7.49394C1.42727 7.2184 1.50107 6.94285 1.58263 6.66731C8.51439 6.988 15.2983 4.59627 20.4937 0C25.6923 4.59877 32.4808 6.99065 39.4164 6.66731C41.4127 13.4522 40.6298 20.7517 37.2399 26.9598C33.85 33.168 28.1308 37.7763 21.3404 39.771C21.0452 39.837 20.7734 39.9263 20.4937 40Z",
    fill: "#3B84E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4238 15.7174V21.5154L15.2659 18.6164V12.8184L20.4238 15.7174Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5818 12.8179L20.4238 15.7169L15.2659 12.8179L20.4238 9.91895L25.5818 12.8179Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5816 12.8184V18.6164L20.4236 21.5154",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3356 24.2867V30.0808L10.1777 27.1857V21.3877L15.3356 24.2867Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1777 21.3873L15.3356 18.4883L20.4935 21.3873V27.1853L15.3356 30.0804",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3357 24.2867L20.4936 21.3877",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8094 21.3877V27.1857L25.6515 30.0808V24.2867L30.8094 21.3877Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6517 30.0804L20.4938 27.1853V21.3873L25.6517 18.4883L30.8096 21.3873",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6517 24.2867L20.4938 21.3877",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/Asset.9004bc8b2d403c655e1f11b21678635f.svg";
export { ForwardRef as ReactComponent };